import { render, staticRenderFns } from "./SidebarGroupChatDetailSm.vue?vue&type=template&id=5d7177ee&scoped=true"
import script from "./SidebarGroupChatDetailSm.vue?vue&type=script&lang=js"
export * from "./SidebarGroupChatDetailSm.vue?vue&type=script&lang=js"
import style0 from "./SidebarGroupChatDetailSm.vue?vue&type=style&index=0&id=5d7177ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7177ee",
  null
  
)

export default component.exports